/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_LOCATION_TYPES_START, GET_LOCATION_TYPES_SUCCESS, GET_LOCATION_TYPES_FAILURE } from './types';
import { ILocationType } from '../../models/Locations/Locations';

export const getLocationTypesStart = () => {
  return {
    type: GET_LOCATION_TYPES_START
  };
};

export const getLocationTypesSuccess = (locationTypes: ILocationType[]) => {
  return {
    type: GET_LOCATION_TYPES_SUCCESS,
    locationTypes
  };
};

export const getLocationTypesFailure = (error: string) => {
  return {
    type: GET_LOCATION_TYPES_FAILURE,
    error
  };
};
